const BigButton = ({ label, handleClick }) => {
    return (
        <button
            className="rounded-3xl w-64 min-h-16 h-auto bg-midnight text-white text-xl py-4 px-6 flex items-center justify-center whitespace-normal leading-tight"
            onClick={handleClick}
        >{label}</button>
    )
}

export default BigButton